export default function Sass_HOME() {
  return (
    <div>
      <h1>Sass HOME</h1>
    </div>
  );
}
